let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("58Rre"), load("gx1TS"), load("gr9Xf")]).then(() => parcelRequire('iFpSu'));